import React from 'react';
import styles from './UserGeneratedTextContainer.scss';

type UserGeneratedTextProps = {
  'data-key'?: ?string,
  text: string,
};
const tokenizer = /(<WARNING>.+?<\/WARNING>)/g;
const capturer = /<WARNING>(.+?)<\/WARNING>/;

const Warning = (props: UserGeneratedTextProps) => (
  <span className={styles.userGeneratedTextWarning}>{props.text}</span>
);

const DefaultUserGeneratedTextSpanProps = {
  className: styles.userGeneratedText + ' lh-copy',
};

const UserGeneratedText = (props: UserGeneratedTextProps) => {
  const { 'data-key': dataKey, text } = props;
  const spanProps =
    dataKey == null
      ? DefaultUserGeneratedTextSpanProps
      : {
          ...DefaultUserGeneratedTextSpanProps,
          'data-key': dataKey,
        };
  return <span {...spanProps}>{text}</span>;
};

export class UserGeneratedTextHighlighter extends React.Component {
  render() {
    return (
      <div className={styles.userGeneratedTextHighlighter}>
        {this.props.children}
      </div>
    );
  }
}

export default function UserGeneratedTextContainer({
  text,
  'data-key': dataKey,
}: UserGeneratedTextProps) {
  const wrappedText = text.split(tokenizer).map((token, index) => {
    const match = capturer.exec(token);

    return match !== null ? (
      <Warning key={`${token}-${index}`} text={match[1]} />
    ) : (
      token
    );
  });
  return <UserGeneratedText data-key={dataKey} text={wrappedText} />;
}

export function stripWarningTags(str: string): string {
  return str.replace(/<\/*WARNING>+/g, '');
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/UserGeneratedTextContainer.js